<template>
    <!--
        Not a link: `CompaniesView` is retired (#295). This component is currently
        not rendered anywhere — `command-results.vue` renders only OrderResult — but
        resolving a retired route name is what threw MATCHER_NOT_FOUND on /depots.
    -->
    <div
        class="hover:bg-muval-gray-6 focus:ring-muval-brand flex h-16 w-full items-center gap-x-4 rounded-md p-2 focus:ring-2 focus:outline-hidden"
        @click="context.context.handleClose"
    >
        <SvgIcon
            name="system-companies"
            class="text-muval-gray-4 size-10"
        />
        <div class="flex w-full max-w-32 flex-col">
            <span class="text-muval-gray-1 truncate font-medium">{{ data.name }}</span>
            <span class="text-muval-gray-2">{{ $filters.capitalize(data.type) }}</span>
        </div>
    </div>
</template>
<script setup>
defineProps({
    data: {
        type: Object,
        required: true,
    },
});

const context = inject('context');
</script>
